












































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import lineas_accion from '@/mixins/axios/pmd_lineas_accions'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,Vuetablepágination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    Vuetablepágination,*/
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
       columnasd:[
             
             
          
           
            
             {
                tag:'linea_accion',
                data:'linea_accion',
                active:true
            },   {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
       ],
   
    



        id:null as any,

      linea_accion:'' as any,
         
              lineas_accion:[] as any,
      
    }
  },
     mixins: [lineas_accion],
     validations: {
    
           linea_accion: {
      required,
    },
   
         
     

   
  },
  methods:{
          select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETEJE',row);
 console.log(row);
 if(row.objetivo==''||row.objetivo==null){
    this.$router.push('/mun/general/pmd/lineas_accion/lineas_accion')
 }else{
    this.$router.push('/mun/general/pmd/lineas_accion_lineas_accion')
 }
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   
//this.getDataDepartamentos();

      
     },
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_PMD_LINEAS_ACCION(row).then(response => {

                    if (response != null) {

 this.lineas_accion=this.lineas_accion.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar linea de acción, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
     
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                
                  this.linea_accion=null;

    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_lineas_accion').modal('show')
      },
seteditar(row){


 this.id=row.id;

  this.linea_accion=row.linea_accion;

          
             
 $('#ac_modal_lineas_accion').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_PMD_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.lineas_accion.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar  linea de acción, refresque la página");

                    }    $("#ac_modal_lineas_accion").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_PMD_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Linea de accion modificada correctamente.");
  this.lineas_accion=this.lineas_accion.filter(item => item.id !== dat.id);
 this.lineas_accion.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear linea de acción, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
        linea_accion:this.linea_accion,

ideje:this.$store.state.eje_sel.id,
//idobjetivo:this.$store.state.objetivo_sel.id,
idestrategia:this.$store.state.estrategia_sel.id,
        idpmd:this.$store.state.pmd_sel.id,
        idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idpmd:this.$store.state.pmd_sel.id,
ideje:this.$store.state.eje_sel.id,
idestrategia:this.$store.state.estrategia_sel.id,
//idobjetivo:this.$store.state.objetivo_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio


};

let data= await this.GET_PMD_LINEAS_ACCION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.lineas_accion=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la página");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

